import { render, staticRenderFns } from "./tabObituaries.vue?vue&type=template&id=fff49550&"
import script from "./tabObituaries.vue?vue&type=script&lang=js&"
export * from "./tabObituaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports